/* eslint-disable */
import { useDisclosure } from '@mantine/hooks';
import { gql, useMutation, useQuery } from '@apollo/client';
import cookie from 'cookie';
import { MainLayout } from '../../Layouts/MainLayout.tsx';
import { Panel } from '../../Primitivas/Panel.tsx';
import {
    Collapse,
    Group,
    Stack,
    Alert,
    Button,
    Flex,
    Modal,
    Text,
    Textarea,
    Title,
    Grid,
} from '@mantine/core';
import { TestRecibirTusFacturasWebhookDocument } from '../../gql/graphql.ts';
import { JsonViewer } from '../Utils/JsonViewer.tsx';
import { GetProblemasQuery, RecibirIpnDocument } from '../../gql/graphql.ts';
import { useState } from 'react';
import { MenuItemsAdmin } from '../../Menu/MenuItemsAdmin.tsx';
import { Env } from '../../Env.ts';
import { captureException } from '@sentry/react';

export function AdminController() {
    const [jwtAbierto, jwtDisclosure] = useDisclosure(false);
    const cookies = cookie.parse(document.cookie);
    const jwt = JSON.parse(window.atob(cookies.sFrontToken)) as {
        up?: { jwt?: string };
    };
    return (
        <MainLayout
            titulo={`Admin`}
            containerSize={'xl'}
            fluid={true}
            menuItems={MenuItemsAdmin}
        >
            <Panel titulo={'Importantdo cuentas'}>
                <Group align={'flex-start'}>
                    <Stack>
                        <Problemas />
                        <JsonViewer value={{ Env }} />
                    </Stack>
                </Group>
            </Panel>
            <Panel titulo={'Acciones'}>
                <Flex
                    gap={10}
                    direction={'column'}
                >
                    <RecibirWebhookRow></RecibirWebhookRow>
                    <RecibirIPNRow></RecibirIPNRow>
                </Flex>
            </Panel>
            <Panel
                titulo={'JWT'}
                extras={
                    <Button onClick={jwtDisclosure.toggle}>
                        {jwtAbierto ? 'Ocultar' : 'Mostrar'}
                    </Button>
                }
            >
                {jwt ? (
                    <Collapse in={jwtAbierto}>
                        <strong>sFrontToken:</strong> <br />
                        <JsonViewer value={jwt} />
                    </Collapse>
                ) : null}
            </Panel>
            <Panel titulo={'Sentry'}>
                <Button
                    onClick={() => {
                        captureException(new Error('Test de eusuario'));
                    }}
                >
                    Probar error
                </Button>
            </Panel>
        </MainLayout>
    );
}

function RecibirWebhookRow() {
    const [isOpen, { open, close }] = useDisclosure();
    const [data, setData] = useState<string>();
    const [recibirWebhook, opts] = useMutation(
        TestRecibirTusFacturasWebhookDocument
    );
    return (
        <Flex
            gap={30}
            align={'center'}
        >
            <Modal
                title={'Recibir webhook'}
                size={'xl'}
                opened={isOpen}
                onClose={close}
            >
                <Text>Pegue el body del webhook, en JSON o string</Text>
                {opts.error ? (
                    <Alert>Ha ocurrido un error: {opts.error.message}</Alert>
                ) : null}
                <Textarea
                    minRows={20}
                    // autosize={true}
                    style={{ minHeight: 300 }}
                    onChange={(evt) => setData(evt.currentTarget.value)}
                ></Textarea>
                <Button
                    loading={opts.loading}
                    onClick={(_evt) => {
                        if (!data) return;
                        // const content = data.startsWith('{')
                        //     ? JSON.stringify(data)
                        //     : data;
                        // console.log('mandando', data);
                        void recibirWebhook({
                            variables: {
                                content: data,
                            },
                            onCompleted() {
                                close();
                            },
                        });
                    }}
                >
                    Recibir
                </Button>
            </Modal>
            <Button
                // disabled={true}
                onClick={open}
            >
                Recibir webhook
            </Button>
            <Text></Text>
        </Flex>
    );
}
function RecibirIPNRow() {
    const [isOpen, { open, close }] = useDisclosure();
    const [data, setData] = useState<string>();
    const [recibirIPN, opts] = useMutation(RecibirIpnDocument);
    return (
        <Flex
            gap={30}
            align={'center'}
        >
            <Modal
                title={'Recibir IPN'}
                size={'xl'}
                opened={isOpen}
                onClose={close}
            >
                <Text>Pegue el body del webhook, en JSON o string</Text>
                {opts.error ? (
                    <Alert>
                        Ha ocurrido un error: <pre>{opts.error.message}</pre>
                    </Alert>
                ) : null}
                <Textarea
                    minRows={20}
                    // autosize={true}
                    style={{ minHeight: 300 }}
                    onChange={(evt) => setData(evt.currentTarget.value)}
                ></Textarea>
                <Button
                    loading={opts.loading}
                    onClick={(_evt) => {
                        if (!data) return;
                        // const content = data.startsWith('{')
                        //     ? JSON.stringify(data)
                        //     : data;
                        // console.log('mandando', data);
                        void recibirIPN({
                            variables: {
                                content: data,
                            },
                            onCompleted() {
                                close();
                            },
                        });
                    }}
                >
                    Recibir
                </Button>
            </Modal>
            <Button
                disabled={true}
                onClick={open}
            >
                Recibir IPN
            </Button>
            <Text></Text>
        </Flex>
    );
}

/**
 * La hago manualmente porque la query devuelve no tipado
 */
interface AnalisisProblemas {
    problemas: string[];
    estadisticas: {
        fecha: string;
        datos: number;
    };
    raw: {
        estadoCuentasEnAuth: {
            cuentas: number;
            usuarios: number;
            cuentas_con_pais: number;
            cuentas_con_udn: number;
        };
        estadoCuentasEnLegacy: {
            total: number;
            bloqueadas: number;
            no_bloqueadas: number;
            sin_auth: number;
            con_pais: number;
            con_udn: number;
        };
        estadoCuentasEnSuscripciones: {
            total: number;
            bloqueadas: number;
            no_bloqueadas: number;
            suscripcion_activa: number;
            trial: number;
            en_migracion: number;
            con_pais: number;
            con_udn: number;
        };
    };
}

function Problemas() {
    const { data, loading } = useQuery<GetProblemasQuery>(gql`
        query getProblemas {
            problemasCuentas
        }
    `);
    const datos = data?.problemasCuentas as AnalisisProblemas | undefined;
    const en_legacy = datos?.raw.estadoCuentasEnLegacy;
    const en_subs = datos?.raw.estadoCuentasEnSuscripciones;
    const en_auth = datos?.raw.estadoCuentasEnAuth;
    const cuentas_en_auth = en_auth?.cuentas?.toLocaleString();
    const usuarios_en_auth = en_auth?.usuarios?.toLocaleString();
    const cuentas_en_auth_con_pais =
        en_auth?.cuentas_con_pais?.toLocaleString();
    const cuentas_en_auth_con_udn = en_auth?.cuentas_con_udn?.toLocaleString();
    // return (
    //     <ul>
    //     </ul>
    // );
    if (loading) return 'Cargando...';
    return (
        <Grid>
            <Grid.Col span={8}>
                <Title order={2}>Problemas</Title>
                <ul>
                    {datos?.problemas.length == 0 ? (
                        <li>Sin Problemas</li>
                    ) : (
                        datos?.problemas.map((problema) => (
                            <li key={problema}> {problema}</li>
                        ))
                    )}
                </ul>
                <Title order={2}>Datos</Title>
                <ul>
                    <li>
                        En Legacy: {en_legacy?.total?.toLocaleString()}
                        <ul>
                            <li>
                                Sin terminar instalación:{' '}
                                {en_legacy?.sin_auth?.toLocaleString()}
                            </li>
                            <li>
                                Bloqueadas:{' '}
                                {en_legacy?.bloqueadas?.toLocaleString()}
                            </li>
                            <li>
                                Con país:{' '}
                                {en_legacy?.con_pais?.toLocaleString()}
                            </li>
                            <li>
                                Con UDN: {en_legacy?.con_udn?.toLocaleString()}
                            </li>
                            <li>
                                No Bloqueadas:{' '}
                                <strong>
                                    {(
                                        (en_legacy?.no_bloqueadas ?? 0) -
                                        (en_legacy?.sin_auth ?? 0)
                                    ).toLocaleString()}
                                </strong>
                            </li>
                        </ul>
                    </li>
                    <li>
                        En Subs: {en_subs?.total?.toLocaleString()}
                        <ul>
                            <li>
                                Con país: {en_subs?.con_pais?.toLocaleString()}
                            </li>
                            <li>
                                Con UDN: {en_subs?.con_udn?.toLocaleString()}
                            </li>
                            <li>
                                por servicio:
                                <ul>
                                    <li>
                                        Bloqueadas:{' '}
                                        {en_subs?.bloqueadas?.toLocaleString()}
                                    </li>
                                    <li>
                                        No Bloqueadas:{' '}
                                        <strong>
                                            {en_subs?.no_bloqueadas?.toLocaleString()}
                                        </strong>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                por estado:
                                <ul>
                                    <li>
                                        <strong>Activas</strong>{' '}
                                        {en_subs?.suscripcion_activa?.toLocaleString()}
                                        {/*<ul>*/}
                                        {/*    <li>al día XXX</li>*/}
                                        {/*    <li>con problemas de pagos XXX</li>*/}
                                        {/*    <li>se le acaba a fin del periodo XXX</li>*/}
                                        {/*</ul>*/}
                                    </li>
                                    <li>
                                        <strong>En trial</strong>{' '}
                                        {en_subs?.trial?.toLocaleString()}
                                    </li>
                                    <li>
                                        <strong>En migración</strong>{' '}
                                        {en_subs?.en_migracion?.toLocaleString()}
                                    </li>
                                </ul>
                            </li>
                            {/*<li>Bloqueadas: XXX</li>*/}
                            {/*<li>Activas: XXX</li>*/}
                        </ul>
                    </li>
                    <li>
                        En Auth:{' '}
                        <ul>
                            <li>Cuentas: {cuentas_en_auth}</li>
                            <li>Usuarios: {usuarios_en_auth}</li>
                            <li>
                                Cuentas con país: {cuentas_en_auth_con_pais}
                            </li>
                            <li>Cuentas con UDN: {cuentas_en_auth_con_udn}</li>
                        </ul>
                    </li>
                </ul>
            </Grid.Col>
            <Grid.Col span={4}>
                <Title order={2}>Estadísticas de ayer</Title>
                <p>
                    {datos?.estadisticas ? (
                        <ul>
                            <li>Fecha: {datos.estadisticas.fecha}</li>
                            <li>
                                Tiendas con estadísticas:{' '}
                                {datos.estadisticas.datos}
                            </li>
                        </ul>
                    ) : (
                        'Sin datos'
                    )}
                </p>
            </Grid.Col>
        </Grid>
    );
}
